export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14925.10c3857f.jpg";